import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'name',
    label: i18n('entities.category.fields.name'),
    schema: schemas.string(
      i18n('entities.category.fields.name'),
      {
        "required": true,
        "max": 32
      },
    ),
  },
  {
    name: 'colour',
    label: i18n('entities.category.fields.colour'),
    schema: schemas.string(
      i18n('entities.category.fields.colour'),
      {
        "max": 16
      },
    ),
  },
  {
    name: 'publicCategory',
    label: i18n('entities.category.fields.publicCategory'),
    schema: schemas.boolean(
      i18n('entities.category.fields.publicCategory'),
      {},
    ),
  },
  {
    name: 'inSearch',
    label: i18n('entities.category.fields.inSearch'),
    schema: schemas.boolean(
      i18n('entities.category.fields.inSearch'),
      {},
    ),
  },
  {
    name: 'displayOrder',
    label: i18n('entities.category.fields.displayOrder'),
    schema: schemas.integer(
      i18n('entities.category.fields.displayOrder'),
      {},
    ),
  },
];